// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useSexesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getSexes = () => {
    return request("GET", `${API_STAGES_URL}/v1/sexes`)
  }

  return [
    requestState,
    payload,
    error,
    {
      getSexes,
    },
  ]
}

export default useSexesApi
